import { TEMPLATE_TYPES } from 'cpool-constants';
import { z } from 'zod';

import type { EventSchema } from '../../utils/EventSchema';
import { _Event } from '../_Event';

export class Template_OfferMailCreated extends _Event {
    getSchema() {
        return z.object({
            active: z.boolean().nullish(),
            mailContent: z.string().min(1),
            mailHTMLContent: z.string().min(1),
            name: z.string().min(1),
            offerItemContent: z.string().optional(),
            offerItemHTMLContent: z.string().optional(),
            priority: z.optional(z.number().int().default(0)),
            subject: z.string().min(1),
            technicalDescription: z.optional(z.string().min(1).nullable()),
            type: z.literal(TEMPLATE_TYPES.OFFER_MAIL),
        });
    }

    static example(): EventSchema<Template_OfferMailCreated> {
        return {
            mailContent: 'This is the mail content',
            mailHTMLContent: '<html><body>This is the mail HTML content</body></html>',
            name: 'Mail Template',
            offerItemContent: 'This is the offer item content',
            offerItemHTMLContent: '<div>This is the offer item HTML content</div>',
            priority: 0,
            subject: 'Mail Template Subject',
            type: TEMPLATE_TYPES.OFFER_MAIL,
        };
    }
}
